<template>
    <div>
        <a-form-model ref="dynamicValidateForm" :model="dynamicValidateForm" v-bind="formItemLayoutWithOutLabel">
            <draggable v-model="dynamicValidateForm.remarks" :sort="true" @end="onEnd">
                <a-form-model-item v-for="(domain, index) in dynamicValidateForm.remarks" :key="index"
                    :prop="'remarks.' + index + '.value'" :rules="{
                        required: true,
                        message: '请输入',
                        trigger: 'blur',
                    }" v-bind="formItemLayout" :label="index + 1">
                    <a-textarea auto-size v-model="domain.value" style="width: 60%; margin-right: 8px"
                        placeholder="please input domain"></a-textarea>
                    <a-icon v-if="dynamicValidateForm.remarks.length > 1" class="dynamic-delete-button"
                        type="minus-circle-o" :disabled="dynamicValidateForm.remarks.length === 1"
                        style=" margin-right: 12px" @click="removeDomain(domain)" />
                    <a-icon type="border-outer" class="dynamic-delete-button" />
                </a-form-model-item>
            </draggable>
            <a-form-model-item v-bind="formItemLayoutWithOutLabel">
                <a-button type="dashed" style="width: 60%" @click="addDomain">
                    <a-icon type="plus" /> 新增一个
                </a-button>
            </a-form-model-item>
            <a-form-model-item v-bind="formItemLayoutWithOutLabel">
                <a-button type="primary" style="width: 60%;" @click="submitForm('dynamicValidateForm')">
                    保存
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
import draggable from "vuedraggable";
export default {
    mixins: [viewModule],
    props: ["trip_id"],
    components: { draggable, },
    data() {
        return {
            dataForm: {
                trip_id: this.trip_id,
            },
            mixinViewModuleOptions: {
                getDataListIsPage: false,
                getDataListURL: "/admin/trip/tripremark",
            },
            formItemLayout: {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 4 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 20 },
                },
            },
            formItemLayoutWithOutLabel: {
                wrapperCol: {
                    xs: { span: 24, offset: 0 },
                    sm: { span: 20, offset: 4 },
                },
            },
            dynamicValidateForm: {
                remarks: [],
            },
        };
    },
    methods: {
        onEnd(e) {
            for (let i = 0; i < this.dynamicValidateForm.remarks.length; i++) {
                this.dynamicValidateForm.remarks[i].sort = i;
            }
            this.dataListLoading = true;
            this.$http({
                url: "/admin/trip/tripremarkupdate",
                method: 'post',
                data: {
                    trip_id: this.trip_id,
                    remarks: this.dynamicValidateForm.remarks,
                },
            }).then(res => {
                this.$message.success(res.message);
            }).finally(() => {
                this.dataListLoading = false;
            });
        },
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.onEnd()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        queryAfter(e) {
            console.log(e)
            this.dynamicValidateForm.remarks = e.data;
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        remove(item) {
            let index = this.dynamicValidateForm.remarks.indexOf(item);
            if (index !== -1) {
                this.dynamicValidateForm.remarks.splice(index, 1);
            }
        },
        removeDomain(item) {
            if (!item.id) {
                this.remove(item)
            } else {
                this.$confirm({
                    title: '是否删除这里项备注?',
                    content: '删除后不可恢复',
                    onOk: () => {
                        this.$http({
                            url: '/admin/trip/tripremarkdelete',
                            method: 'post',
                            data: {
                                ids: [item.id],
                            },
                        }).then(() => {
                            this.$message.success('删除成功');
                            this.remove(item)
                        })
                    },
                });
            }

        },
        addDomain() {
            this.dynamicValidateForm.remarks.push({
                value: '',
            });
        },
    }
};
</script>

<style scoped>
.dynamic-delete-button {
    cursor: pointer;
    position: relative;
    top: 4px;
    font-size: 24px;
    color: #999;
    transition: all 0.3s;
}

.dynamic-delete-button:hover {
    color: #777;
}

.dynamic-delete-button[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
}
</style>